import React, { memo } from "react";
import { Box, CircularProgress, Typography } from "@mui/material";
import { COLORS, FONT } from "../../shared/styles";
import SettingsSecondaryButton from "../../shared/SettingsSecondaryButton";

const labelSx = {
  color: COLORS.textSecondary,
  fontFamily: FONT.family,
  fontSize: "12px",
  fontWeight: 400,
  lineHeight: "normal",
  mb: "8px",
};

function WidgetLogoField({
  logoPreview,
  onUploadClick,
  loading = false,
  disabled = false,
  hasPendingFile = false,
}) {
  return (
    <Box>
      <Typography sx={labelSx}>Widget Logo</Typography>
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          gap: "16px",
          minHeight: "72px",
          borderRadius: "8px",
          border: `1px solid ${COLORS.border}`,
          background: COLORS.white,
          p: "16px",
        }}
      >
        <Box sx={{ display: "flex", alignItems: "center", gap: "12px", minWidth: 0 }}>
          <Box
            sx={{
              width: 40,
              height: 40,
              borderRadius: "8px",
              border: `1px solid ${COLORS.borderLight}`,
              background: "#F9FAFA",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              overflow: "hidden",
              flexShrink: 0,
            }}
          >
            {loading ? (
              <CircularProgress size={20} sx={{ color: COLORS.primary }} />
            ) : logoPreview ? (
              <Box
                component="img"
                src={logoPreview}
                alt=""
                sx={{ width: "100%", height: "100%", objectFit: "cover" }}
              />
            ) : (
              <Typography
                sx={{
                  color: COLORS.primary,
                  fontFamily: FONT.family,
                  fontSize: "14px",
                  fontWeight: 600,
                }}
              >
                TC
              </Typography>
            )}
          </Box>
          <Box sx={{ minWidth: 0 }}>
            <Typography
              sx={{
                color: COLORS.textPrimary,
                fontFamily: FONT.family,
                fontSize: "14px",
                fontWeight: 500,
                lineHeight: "18px",
              }}
            >
              {logoPreview ? "Widget logo" : "No logo uploaded"}
            </Typography>
            <Typography
              sx={{
                mt: "4px",
                color: COLORS.textSecondary,
                fontFamily: FONT.family,
                fontSize: "12px",
                fontWeight: 400,
                lineHeight: "16px",
              }}
            >
              Recommended size: 200x200px, PNG or JPG
            </Typography>
          </Box>
        </Box>
        <SettingsSecondaryButton
          onClick={onUploadClick}
          disabled={disabled || loading}
          sx={{ flexShrink: 0 }}
        >
          {hasPendingFile || logoPreview ? "Change Logo" : "Upload Logo"}
        </SettingsSecondaryButton>
      </Box>
    </Box>
  );
}

export default memo(WidgetLogoField);
